import React, { HTMLAttributes } from 'react';
import { cn } from '../../utils/cn';

type BadgeVariant =
  | 'default'
  | 'success'
  | 'error'
  | 'warning'
  | 'info'
  | 'verified'
  | 'pending'
  | 'active'
  | 'unused';
type BadgeSize = 'small' | 'medium' | 'large';

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
  size?: BadgeSize;
  className?: string;
}

const Badge: React.FC<BadgeProps> = ({
  className,
  variant = 'default',
  size = 'medium',
  children,
  ...props
}) => {
  const baseStyles = 'inline-flex items-center rounded-full font-medium';

  const variants: Record<BadgeVariant, string> = {
    default: 'bg-muted text-muted-foreground',
    success: 'bg-success text-success-foreground',
    error: 'bg-destructive text-destructive-foreground',
    warning: 'bg-warning text-warning-foreground',
    info: 'bg-info text-info-foreground',
    verified: 'bg-success text-success-foreground',
    pending: 'bg-warning text-warning-foreground',
    active: 'bg-primary text-primary-foreground',
    unused: 'bg-muted text-muted-foreground',
  };

  const sizes: Record<BadgeSize, string> = {
    small: 'px-2 py-1 text-xs',
    medium: 'px-2.5 py-1 text-sm',
    large: 'px-3 py-1.5 text-base',
  };

  return (
    <span
      className={cn(baseStyles, variants[variant], sizes[size], className)}
      {...props}
    >
      {children}
    </span>
  );
};

export default Badge;
